/* Bloco de tamanhos: filtro de bastidor, janela "Outro", expandir/recolher, memoria entre produtos.
   A truncagem inicial NAO depende deste arquivo - ela vem por classe do servidor. Aqui so acontece
   o que exige interacao. Se este script nao carregar, a pagina continua correta e completa.
   Decisoes e medicoes: Workshop Claude/SKILLS/pdp-ordem-de-servico.md 2.5 */
(function () {
  'use strict';

  var CHAVE = 'artesao:bastidor';
  // 200cm: o maior campo de bordado do mundo e 160x160 (Tajima/IIGM). Acima disso e erro de
  // digitacao. Contar digito nao serve: 99 polegadas dariam 251cm.
  var MAX_CM = 200;
  var ORC_CEL = 15, ORC_DESK = 18, MIN_LINHAS = 3, MIN_ESCONDIDAS = 3;

  function guardar(v) {
    try {
      if (v) localStorage.setItem(CHAVE, JSON.stringify(v));
      else localStorage.removeItem(CHAVE);
    } catch (e) { /* aba anonima e cookies bloqueados lancam aqui; nunca derrubar a pagina */ }
  }
  function lembrar() {
    try {
      var c = JSON.parse(localStorage.getItem(CHAVE) || 'null');
      if (c && c.a > 0 && c.b > 0 && c.a <= MAX_CM && c.b <= MAX_CM) return c;
    } catch (e) {}
    return null;
  }

  // "8cm" (uma dimensao) vira 8x8 - pior caso. "86mm x125mm" e "30x18mm" existem no catalogo.
  function medidaDe(txt) {
    var t = String(txt).trim();
    var mm = /mm/i.test(t);
    var n = t.split(/x/i).map(function (s) {
      return parseFloat(String(s).replace(',', '.').replace(/[^\d.]/g, ''));
    });
    var a = n[0], b = n.length > 1 ? n[1] : n[0];
    if (!(a > 0) || !(b > 0)) return null;
    if (mm) { a /= 10; b /= 10; }
    return { a: a, b: b };
  }
  // encaixe COM rotacao: 18x13 cabe em 13x18, qualquer software gira 90 graus
  function cabe(m, c, d) {
    return Math.min(m.a, m.b) <= Math.min(c, d) + 1e-9 &&
           Math.max(m.a, m.b) <= Math.max(c, d) + 1e-9;
  }
  function numero(v) { return (Math.round(v * 10) / 10 + '').replace('.', ','); }

  // Faz a lista DESLIZAR entre dois tamanhos em vez de pular (26/08/2026).
  // Antes: clicar em "Ver todos" trocava as classes e o bloco ia de 554px pra 2049px num quadro so -
  // 1495px de salto de uma vez, medido na Colecao Aventura Marinha a 390px.
  //
  // Anima a `.tam-lista`, NAO a `.tam-corte`: o veu e o botao flutuante sao filhos absolutos da
  // `.tam-corte` (o botao mora em `bottom:-4px`), e por um `overflow:hidden` nela durante a
  // animacao cortaria os dois. A `.tam-corte` cresce sozinha junto com a lista.
  //
  // `mudar` e a funcao que troca as classes. Ela roda com a lista JA no tamanho final; a medicao
  // do antes acontece antes dela, a do depois logo em seguida, e a animacao vai de uma pra outra.
  // NAO por de volta um teste de user agent pra desligar isto na webview do Instagram/Facebook.
  // Existiu por algumas horas em 26/08/2026 e saiu no dia seguinte. Medido com a CPU estrangulada
  // (`Workshop Claude/mede-custo-animacao.mjs`): a 6x, que e aparelho fraco, a gaveta perde UM
  // quadro em 17; so a 10x ela treme. O medo era o tamanho do movimento (1495px na maior colecao),
  // e o tamanho nao e o que custa - o custo e por quadro, e cada quadro e barato.
  // A unica coisa que a pessoa pediu e que a gente obedece e `prefers-reduced-motion`.
  function deslizar(el, mudar) {
    var reduz = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduz || !el) { mudar(); return; }
    var de = el.getBoundingClientRect().height;
    mudar();
    var para = el.getBoundingClientRect().height;
    // diferenca insignificante (ou nenhuma linha escondida): nao vale animar nada
    if (Math.abs(para - de) < 6) return;
    var limpou = false;
    var limpar = function () {
      if (limpou) return; limpou = true;
      el.style.transition = ''; el.style.height = ''; el.style.overflow = '';
    };
    el.style.overflow = 'hidden';
    el.style.height = de + 'px';
    el.getBoundingClientRect();                 // forca o navegador a assumir a altura inicial
    el.style.transition = 'height .32s cubic-bezier(.22,.61,.36,1)';
    el.style.height = para + 'px';
    el.addEventListener('transitionend', function h(ev) {
      if (ev.target !== el || ev.propertyName !== 'height') return;
      el.removeEventListener('transitionend', h); limpar();
    });
    // Rede de seguranca: se o transitionend nunca chegar, o pior caso e a lista aparecer de uma vez -
    // NUNCA ficar presa com uma altura inline errada, que esconderia tamanhos pra sempre.
    setTimeout(limpar, 420);
  }

  function iniciar(bloco) {
    var corte = bloco.querySelector('[data-corte]');
    var lista = bloco.querySelector('.tam-lista');
    var btAbrir = bloco.querySelector('[data-abrir]');
    var btAbrirTxt = bloco.querySelector('[data-abrir-txt]');
    var btRecolher = bloco.querySelector('[data-recolher]');
    var status = bloco.querySelector('[data-status]');
    var msg = bloco.querySelector('[data-msg]');
    var msgTxt = bloco.querySelector('[data-msg-txt]');
    var btOutro = bloco.querySelector('[data-outro]');
    var janela = document.querySelector('[data-janela]');
    // A janela nasce dentro da coluna da descricao, e la ela abria centrada NA COLUNA, nao na tela.
    // position:fixed deixa de olhar o viewport quando algum ancestral tem transform, filter ou
    // contain - e o bloco de tamanhos usa container-type, que implica contain. Mover pro <body>
    // resolve na raiz e nao depende de descobrir qual ancestral e o culpado.
    if (janela && janela.parentNode !== document.body) document.body.appendChild(janela);
    var linhas = [].slice.call(bloco.querySelectorAll('.tam-linha'));
    if (!linhas.length) return;

    // le os numeros UMA vez; dai em diante so troca classe
    linhas.forEach(function (ln) {
      ln._pils = [].slice.call(ln.querySelectorAll('.tam-pil')).map(function (p) {
        return { el: p, m: medidaDe(p.textContent) };
      });
    });

    var bastidor = null, rotulo = '', rotuloCurto = '', digitado = false, aberto = false, salvo = null;
    // o total do PRODUTO (nao o da lista filtrada) vem do metafield via data-total.
    // Guarda: se vier vazio ou zero, conta as pilulas do DOM - a mensagem nunca pode dizer
    // "18 dos 0 tamanhos".
    var total = parseInt(bloco.dataset.total, 10);
    if (!(total > 0)) total = bloco.querySelectorAll('.tam-pil').length;

    // mede o BLOCO, nao a janela: e o mesmo criterio da container query do CSS (440px).
    // Usar matchMedia aqui faria o JS e o CSS discordarem em viewport largo com coluna estreita.
    function largo() { return bloco.getBoundingClientRect().width >= 440; }
    function orcamento() { return largo() ? ORC_DESK : ORC_CEL; }
    function quantas(visiveis) {
      var orc = orcamento(), soma = 0, n = 0;
      for (var i = 0; i < visiveis.length; i++) {
        var custo = visiveis[i]._vivas;
        if (n >= MIN_LINHAS && soma + custo > orc) break;
        soma += custo; n++;
      }
      return Math.max(MIN_LINHAS, Math.min(n, visiveis.length));
    }

    function aplicar(anunciar) {
      var sobrou = 0, vivasTotal = 0;

      linhas.forEach(function (ln) {
        var vivas = 0;
        ln._pils.forEach(function (p) {
          var ok = !bastidor || !p.m || cabe(p.m, bastidor[0], bastidor[1]);
          if (ok) {
            if (p.el.classList.contains('some')) {
              p.el.classList.remove('some');
              void p.el.offsetWidth;              // reflow: sem isso a transicao nao roda
              p.el.classList.remove('saindo');
            }
            vivas++;
          } else if (!p.el.classList.contains('some')) {
            p.el.classList.add('saindo');
            setTimeout(function () {
              if (p.el.classList.contains('saindo')) p.el.classList.add('some');
            }, 180);
          }
        });
        ln._vivas = vivas;
        ln.classList.toggle('some', vivas === 0);
        if (vivas) { sobrou++; vivasTotal += vivas; }
      });

      var nada = sobrou === 0;
      if (msg) {
        // As tres frases sao do Eldom (25/08/2026) e tem a MESMA estrutura de proposito: muda o
        // dado, nao a forma. E contam em TAMANHOS, a mesma unidade do botao de expandir - contar
        // pecas aqui e tamanhos ali fazia a pagina falar em duas moedas.
        var comFiltro = !!bastidor;
        msg.hidden = !comFiltro;
        msg.classList.toggle('ok', !nada);
        var corrigir = msg.querySelector('[data-msg-corrigir]');
        // so quem DIGITOU tem o que corrigir; pra quem clicou num chip o botao seria um beco
        if (corrigir) corrigir.style.display = (nada && digitado) ? '' : 'none';
        // A palavra `inclusos` e do Eldom (27/08/2026) e resolve o problema mais caro que a
        // pagina tinha. Antes: a frase acima da grade dizia "Voce recebe TODOS estes tamanhos",
        // e "estes" apontava pra grade - que o filtro ENCOLHE. Sem mudar uma letra, a promessa
        // virava menor, e a cliente concluia que clicar em 10x10 significava receber so o 10x10
        // (e que clicar em 13x18 sairia mais caro). Isso e combustivel pra pedido de desconto.
        //
        // ⚠️ A palavra vai DENTRO da contagem, nao anexada depois. Eu tinha proposto anexar
        // ("...mas voce recebe todos os 23"); o Eldom botou dentro e e melhor, porque assim o
        // numero ja NASCE significando entrega, nos tres estados, sem precisar de "mas".
        // ⚠️ `inclusos`, nao "inclusos no pacote": 48 produtos ativos sao "Matriz", nao pacote.
        // ⚠️ As tres frases tem a MESMA forma de proposito: muda o dado, nao a estrutura.
        if (comFiltro && msgTxt) {
          if (nada) {
            // Sem exclamacao e sem tranquilizar. Aqui a matriz NAO serve: `.PES` e `.JEF` gravam
            // o bastidor no cabecalho e a maquina se recusa a comecar. Dizer "mas voce recebe
            // todos!" seria empurrar arquivo que ela nao consegue bordar.
            // ⚠️ O negrito e SEMPRE a quantidade + o nome do bastidor, nos tres estados. Ate
            // 28/08 o "Todos os 69" e o "Nenhum dos 69" saiam sem negrito enquanto o "31 dos 69"
            // saia com, e a mensagem mudava de peso conforme o chip clicado. Achado do Eldom.
            msgTxt.innerHTML = '<b>Nenhum dos ' + total + '</b> tamanhos inclusos cabe no bastidor <b>' +
              rotuloCurto + '</b>' + (digitado ? '. Confira as medidas que você digitou.' : ', escolha outro.');
          } else if (vivasTotal >= total) {
            msgTxt.innerHTML = '<b>Todos os ' + total + '</b> tamanhos inclusos cabem no bastidor <b>' +
              rotuloCurto + '</b>!';
          } else {
            msgTxt.innerHTML = '<b>' + vivasTotal + ' dos ' + total + '</b> tamanhos inclusos ' +
              'cabem no bastidor <b>' + rotuloCurto + '</b>!';
          }
        }
      }

      var visiveis = linhas.filter(function (l) { return !l.classList.contains('some'); });
      var lim = quantas(visiveis);
      var valeTruncar = !nada && visiveis.length - lim >= MIN_ESCONDIDAS;

      // com filtro ligado, a truncagem do servidor nao vale mais: o JS reassume
      if (bastidor) {
        linhas.forEach(function (l) { l.classList.remove('cel-esconde', 'desk-esconde'); });
        visiveis.forEach(function (l, i) {
          if (!aberto && valeTruncar && i > lim) l.classList.add('cel-esconde', 'desk-esconde');
        });
      }

      // o servidor marcou tem-corte-cel/desk pro caso de este script nunca rodar. Rodou:
      // apaga as duas e assume. Duas autoridades ao mesmo tempo dariam veu sobre lista inteira.
      bloco.classList.remove('tem-corte-cel', 'tem-corte-desk');
      bloco.classList.toggle('tem-corte', valeTruncar);
      bloco.classList.toggle('aberto', aberto);
      if (btAbrir) btAbrir.setAttribute('aria-expanded', aberto ? 'true' : 'false');
      // o rotulo conta o que ESTA na lista agora: com filtro ligado, o total do produto seria mentira
      if (btAbrirTxt) btAbrirTxt.textContent = 'Ver todos os ' + vivasTotal + ' tamanhos';

      if (anunciar && status) {
        // quem usa leitor de tela ouve SO isto: a garantia de entrega tem que estar aqui
        // tambem, senao "3 tamanhos disponiveis" soa como "voce vai receber 3".
        status.textContent = nada
          ? 'Nenhum dos ' + total + ' tamanhos inclusos cabe nesse bastidor.'
          : vivasTotal + ' de ' + total + ' tamanhos inclusos cabem' +
            (rotulo ? ' no bastidor ' + rotulo : '') + '.';
      }
    }

    function marcar(ativo) {
      [].forEach.call(bloco.querySelectorAll('.tam-bt'), function (o) {
        o.setAttribute('aria-pressed', o === ativo ? 'true' : 'false');
      });
    }

    [].forEach.call(bloco.querySelectorAll('.tam-bt[data-bast]'), function (b) {
      b.addEventListener('click', function () {
        var v = b.dataset.bast;
        if (v === 'todos') { bastidor = null; rotulo = ''; rotuloCurto = ''; }
        else { var d = v.split('x'); bastidor = [+d[0], +d[1]]; rotulo = v + ' cm'; rotuloCurto = v; }
        digitado = false;
        // Chip de preset NAO e salvo (Eldom, 25/08): clicar em 13x18 custa um toque, digitar
        // 16x26 custa muito mais. Lembramos so o que custa caro. E a escolha guardada dele
        // sobrevive a este clique de proposito - nao chamamos guardar() aqui.
        marcar(b);
        aplicar(true);
      });
    });

    if (btAbrir) btAbrir.addEventListener('click', function () {
      deslizar(lista, function () { aberto = true; aplicar(false); });
      // o foco tem que seguir o conteudo revelado, senao quem usa teclado fica num botao que sumiu
      var primeira = linhas.filter(function (l) { return !l.classList.contains('some'); })[0];
      if (primeira) { primeira.setAttribute('tabindex', '-1'); primeira.focus(); }
    });
    if (btRecolher) btRecolher.addEventListener('click', function () {
      deslizar(lista, function () { aberto = false; aplicar(false); });
      corte.scrollIntoView({ block: 'start', behavior: 'smooth' });
      if (btAbrir) btAbrir.focus();
    });

    // ---------------- janela "Outro" ----------------
    if (janela && btOutro) {
      var iA = janela.querySelector('[data-ja]'), iB = janela.querySelector('[data-jb]');
      var uni = janela.querySelector('[data-juni]'), conv = janela.querySelector('[data-jconv]');
      var ok = janela.querySelector('[data-jok]'), cancel = janela.querySelector('[data-jcancel]');
      var ultimoFoco = null;

      function fator() { return uni.value === 'mm' ? 0.1 : (uni.value === 'pol' ? 2.54 : 1); }
      function teto() { return uni.value === 'mm' ? 2000 : (uni.value === 'pol' ? 78 : MAX_CM); }
      function ajustar() {
        var pol = uni.value === 'pol';
        [iA, iB].forEach(function (i) {
          i.inputMode = pol ? 'decimal' : 'numeric';
          i.step = pol ? '0.5' : '1';
          i.max = teto();
        });
        previa();
      }
      function valores() {
        return [parseFloat(String(iA.value).replace(',', '.')),
                parseFloat(String(iB.value).replace(',', '.'))];
      }
      function previa() {
        var v = valores(), a = v[0], b = v[1];
        var alto = a > teto() || b > teto();
        ok.disabled = alto;
        if (alto) {
          conv.innerHTML = '<b>Confira esse número:</b> ' + teto() + ' ' +
            (uni.value === 'pol' ? 'polegadas' : uni.value) +
            ' já é maior que qualquer bastidor que existe.';
          return;
        }
        if (!(a > 0 && b > 0) || uni.value === 'cm') { conv.innerHTML = ''; return; }
        var f = fator();
        conv.innerHTML = 'Equivale a <b>' + numero(a * f) + ' x ' + numero(b * f) + ' cm</b>';
      }
      function abrirJanela() {
        ultimoFoco = document.activeElement;
        janela.hidden = false;
        // pre-preenche com a ultima medida digitada: e o unico jeito de "lembrar o bastidor"
        // sem ligar filtro nenhum. Nao adianta condicionar a campo vazio - o Liquid ja nasce com
        // value="10" nos dois, entao a guarda de "vazio" nunca era verdade e o 10x10 vencia.
        if (salvo) {
          uni.value = 'cm';
          iA.value = String(salvo.a);
          iB.value = String(salvo.b);
        }
        ajustar();
        setTimeout(function () { iA.focus(); iA.select(); }, 30);
      }
      function fecharJanela() {
        janela.hidden = true;
        if (ultimoFoco) ultimoFoco.focus();
      }
      uni.addEventListener('change', ajustar);
      [iA, iB].forEach(function (i) { i.addEventListener('input', previa); });
      btOutro.addEventListener('click', abrirJanela);
      cancel.addEventListener('click', fecharJanela);
      janela.addEventListener('click', function (e) { if (e.target === janela) fecharJanela(); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !janela.hidden) fecharJanela();
      });
      if (msg) {
        var c = msg.querySelector('[data-msg-corrigir]');
        if (c) c.addEventListener('click', abrirJanela);
      }
      ok.addEventListener('click', function () {
        var v = valores(), f = fator(), a = v[0] * f, b = v[1] * f;
        if (!(a > 0 && b > 0) || a > MAX_CM || b > MAX_CM) { iA.focus(); return; }
        bastidor = [a, b];
        rotulo = numero(a) + ' x ' + numero(b) + ' cm';
        rotuloCurto = numero(a) + 'x' + numero(b);
        digitado = true;
        btOutro.innerHTML = numero(a) + 'x' + numero(b) +
          ' <svg class="lapis" width="12" height="12" viewBox="0 0 16 16" fill="none" aria-hidden="true">' +
          '<path d="M11.5 2.5l2 2L6 12l-3 1 1-3 7.5-7.5z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg>';
        btOutro.setAttribute('aria-label', 'Bastidor ' + rotulo + '. Tocar para alterar.');
        salvo = { a: a, b: b };
        guardar({ a: a, b: b, rot: rotulo, fixo: '' });
        marcar(btOutro);
        fecharJanela();
        aplicar(true);
      });

      // Ao abrir a pagina, TODA pagina, o estado e sempre "Ver todos" (Eldom, 25/08).
      // A memoria devolve so o ROTULO do chip Outro e pre-enche a janela - nunca liga o filtro.
      // Motivo: um filtro herdado de outro produto esconde tamanhos em silencio, e ela conclui
      // "esse projeto so tem 3 tamanhos" sem saber que ela mesma ligou aquilo tres paginas atras.
      // Digitar as medidas custa caro e fica lembrado; aplicar custa um toque e nao se presume.
      // O "Ver todos" ja nasce aceso pelo Liquid (aria-pressed="true"), entao sem JS tambem vale.
      var mem = lembrar();
      if (mem && !mem.fixo) {
        salvo = { a: mem.a, b: mem.b };
        btOutro.innerHTML = numero(mem.a) + 'x' + numero(mem.b) +
          ' <svg class="lapis" width="12" height="12" viewBox="0 0 16 16" fill="none" aria-hidden="true">' +
          '<path d="M11.5 2.5l2 2L6 12l-3 1 1-3 7.5-7.5z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg>';
        btOutro.setAttribute('aria-label', 'Bastidor ' + mem.rot + '. Tocar para usar ou alterar.');
      } else if (mem && mem.fixo) {
        guardar(null);   // sobra da versao que salvava preset; nao serve mais
      }
    }

    aplicar(false);
    window.addEventListener('resize', function () { aplicar(false); });
  }

  function iniciarTodos() {
    [].forEach.call(document.querySelectorAll('[data-tam]'), iniciar);
  }
  if (document.readyState === 'loading')
    document.addEventListener('DOMContentLoaded', iniciarTodos);
  else iniciarTodos();
})();
